import { Helmet } from "react-helmet-async";

const SITE = "https://fardriverturkiye.com";
const DEFAULT_TITLE = "Fardriver Türkiye - Elektrikli Motor Beyin & Kontrolör Tedarikçisi";
const DEFAULT_DESC =
  "Fardriver Türkiye, elektrikli motosiklet kontrolörleri (motor beyin) tedarikçisi. FOC sinüs ND72450, ND72360, MINI12 ve tüm Fardriver modellerinin Türkiye satışı.";
const DEFAULT_KEYWORDS =
  "fardriver, far driver, far-driver, fardriver türkiye, elektrikli motor beyin, elektrikli motor kontrolör, motor controller, foc kontrolör, ND72450, ND72360, ND72300, NS721000, MINI12, elektrikli motosiklet, elektrikli scooter, elektrikli atv, motor kontrol kartı, bluetooth motor kontrolör";
const DEFAULT_OG = "https://fardriverturkiye.com/og-image.jpg";

export default function SEO({
  title,
  description,
  keywords,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  product,
}) {
  const fullTitle = title ? `${title} | Fardriver Türkiye` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const kw = keywords || DEFAULT_KEYWORDS;
  const url = `${SITE}${path}`;

  const orgLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Fardriver Türkiye",
    url: SITE,
    logo: `${SITE}/og-image.jpg`,
    description: DEFAULT_DESC,
    address: {
      "@type": "PostalAddress",
      streetAddress: "Fulya Mah. Garaj Sk. No:7 Kat:1 Daire:5",
      addressLocality: "Şişli",
      addressRegion: "İstanbul",
      addressCountry: "TR",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+90-505-745-3532",
      contactType: "sales",
      areaServed: "TR",
      availableLanguage: ["Turkish"],
    },
  };

  const productLd =
    product && {
      "@context": "https://schema.org",
      "@type": "Product",
      name: product.name,
      description: product.short_description || product.description,
      image: product.image_url?.startsWith("/") ? SITE + product.image_url : product.image_url,
      brand: { "@type": "Brand", name: "Fardriver" },
      manufacturer: { "@type": "Organization", name: "Fardriver" },
      category: product.category,
      sku: product.slug,
      mpn: product.slug?.toUpperCase(),
      url,
    };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="author" content="Fardriver Türkiye" />
      <meta httpEquiv="Content-Language" content="tr" />
      <meta name="language" content="Turkish" />
      <meta name="geo.region" content="TR-34" />
      <meta name="geo.placename" content="İstanbul" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="Fardriver Türkiye" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {/* Schema.org */}
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      {productLd && <script type="application/ld+json">{JSON.stringify(productLd)}</script>}
    </Helmet>
  );
}
